// KPI Builder — spread across value ranges. Shape of the live “Time-on-Task Distribution” histograms.
import { envelope, filterFor, RecipeContext, RecipeResult } from './queries';
import { RangeBucket } from './types';

const bound = (key: 'from' | 'to', v: string): Record<string, number> => (v.trim() === '' ? {} : { [key]: Number(v) });

export const rangeBuckets = (ranges: RangeBucket[]): Record<string, string | number>[] =>
  ranges.map((r) => ({ key: r.label, ...bound('from', r.from), ...bound('to', r.to) }));

export const isRangeReady = (field: string, ranges: RangeBucket[]): boolean =>
  field.trim() !== '' && ranges.length >= 2 && ranges.every((r) => r.label.trim() !== '' && (r.from.trim() !== '' || r.to.trim() !== '') && !Number.isNaN(Number(r.from || 0)) && !Number.isNaN(Number(r.to || 0)));

export function buildRanges(c: RecipeContext): RecipeResult {
  const { a } = c;
  const { rangeField, ranges } = a.custom;
  const buckets = rangeBuckets(ranges);
  const aggs = { filtered_data: { filter: filterFor(c.srcId, a), aggs: { duration_bins: { range: { field: rangeField.trim(), keyed: false, ranges: buckets } } } } };
  return {
    queries: [{ ...envelope(c.srcId, a), filterPath: 'aggregations.filtered_data.duration_bins.buckets', aggrQuery: { size: 0, aggs } }],
    cfg: { chartType: 'histogram', isDecimal: false, aggregationPaths: ['duration_bins'], filterAggName: 'filtered_data' },
    handlerKey: 'histogram',
  };
}
